import React, { createElement } from 'react';

import { BlocksIcon, MicIcon } from 'lucide-react';

import AgoraVoice from '@/components/atoms/Icons/AgoraVoice';
import { EmailIcon } from '@/components/atoms/Icons/EmailIcon';
import Facebook from '@/components/atoms/Icons/Facebook';
import Front from '@/components/atoms/Icons/Front';
import Infobip from '@/components/atoms/Icons/Infobip';
import IconInstagram from '@/components/atoms/Icons/Instagram';
import IconIntercom from '@/components/atoms/Icons/Intercom';
import IconLiveChat from '@/components/atoms/Icons/LiveChat';
import IconSlack from '@/components/atoms/Icons/Slack';
import IconSmartlead from '@/components/atoms/Icons/Smartlead';
import Sunco from '@/components/atoms/Icons/Sunco';
import TelnyxVoice from '@/components/atoms/Icons/TelnyxVoice';
import TwilioVoice from '@/components/atoms/Icons/TwilioVoice';
import Viber from '@/components/atoms/Icons/Viber';
import IconWebWidget from '@/components/atoms/Icons/WebWidget';
import Whatsapp from '@/components/atoms/Icons/Whatsapp';
import Zendesk from '@/components/atoms/Icons/Zendesk';
import { Icon } from '@/shared/types/icon';
import { IntegrationType } from '@/shared/types/integration';

export const iconComponents: Record<IntegrationType, React.FC<Icon>> = {
  [IntegrationType.WEB]: IconWebWidget,
  [IntegrationType.FACEBOOK]: Facebook,
  [IntegrationType.FRONT]: Front,
  [IntegrationType.INFOBIP_SMS]: Infobip,
  [IntegrationType.INFOBIP_RCS]: Infobip,
  [IntegrationType.INTERCOM]: IconIntercom,
  [IntegrationType.LIVECHAT]: IconLiveChat,
  [IntegrationType.SUNCO]: Sunco,
  [IntegrationType.VIBER]: Viber,
  [IntegrationType.MSTAT_VIBER]: Viber,
  [IntegrationType.WHATSAPP]: Whatsapp,
  [IntegrationType.ZENDESK]: Zendesk,
  [IntegrationType.INSTAGRAM]: IconInstagram,
  [IntegrationType.SLACK]: IconSlack,
  [IntegrationType.SMARTLEAD]: IconSmartlead,
  [IntegrationType.TWILIO_VOICE]: TwilioVoice,
  [IntegrationType.TELNYX_VOICE]: TelnyxVoice,
  [IntegrationType.WEB_VOICE]: MicIcon as typeof IconWebWidget,
  [IntegrationType.AGORA_VOICE]: AgoraVoice,
  [IntegrationType.EMAIL]: EmailIcon,
  [IntegrationType.CUSTOM]: BlocksIcon as typeof IconWebWidget,
};

export const IntegrationIcon = ({ type, ...props }: Icon & { type: IntegrationType }) => {
  const IconComponent = iconComponents[type];
  if (!IconComponent) {
    return null;
  }
  return createElement(IconComponent, props);
};

export const getIntegrationIcon = (type: IntegrationType): React.FC<Icon> | undefined =>
  iconComponents[type];
